module.exports = "/_next/static/images/contact_1-57f48523fe0d54a4fe8851526fc1937c.png";